export const API_fachgruppen = process.env.API_URL + '/doctors/groups/';



// WEBPACK FOOTER //
// ./src/constants/API.js